import React, { useState } from "react";
import { useQuery } from "react-query";
import { useSnackbar } from "notistack";
import classNames from "classnames";

import { Column, Row } from "components/Layout";
import IntervalBar from "components/IntervalBar/IntervalBar";
import WeatherWidget from "components/WeatherWidget";
import Charts from "./Charts";
import Tables from "./Tables";
import styles from "./_charts.module.scss";

import {
	getTodayData, getWeeklyData, getMonthlyData, getCustomData,
	getForecastData1Day, getForecastData5Days,
	useGetDevices
} from "service/AgrismartService";
import { getErrorMessage } from "service/Client";


export default function IntervalPage({type, display}) {

	const [device, setDevice] = useState();
	const [interval, setInterval] = useState("daily");
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const [forecastEn, setForecastEn] = useState(false)
	const {enqueueSnackbar} = useSnackbar();
	let {devices} = useGetDevices()

	function showError(e) {
		enqueueSnackbar(getErrorMessage(e), { variant: "error" });
	}

	let { data } = useQuery(['data', { device, interval, startDate, endDate }], () => {
		let promise
		
		if (!device) return;
		if (interval === "daily") {
			promise = getTodayData(device);
		} else if (interval === "weekly") {
			promise = getWeeklyData(device);
		} else if (interval === "monthly") {
			promise = getMonthlyData(device);
		} else if (startDate !== null && endDate !== null) {
			promise = getCustomData(device, startDate.format("DD-MM-YYYY"), endDate.format("DD-MM-YYYY"));
		}
		return promise
	}, {
		enabled: !!device && (interval !== 'custom' || (!!startDate && !!endDate)),
		initialData: [],
		onError: showError,
		refetchInterval: (interval === 'daily') ? 10000 : false,
	})

	let { data: forecastData } = useQuery(['forecastData', { device, interval }], () => {
		let promise
		let deviceObj

		if (!device) return;
		deviceObj = devices.find(d => d.device === device);
		if (forecastEn && interval === "daily") {
			promise = getForecastData1Day(deviceObj);
		} else if (forecastEn && interval === "weekly") {
			promise = getForecastData5Days(deviceObj);
		}
		return promise
	}, {
		enabled: forecastEn && (interval === 'daily' || interval === 'weekly'),
		initialData: [],
		onError: showError,
		refetchInterval: false,
	})

	if(devices.length === 0) return <div/>
	if(!device) {
		setDevice(devices[0].device)
	}

	let deviceObj = devices.find(d => d.device === device);
	let dataWithForecast = forecastEn ? [...data, ...forecastData] : data

	return (
		<div className={classNames("animated", "fadeIn", styles.box)}>
			<IntervalBar
				devices={devices}
				device={device}
				setDevice={setDevice}
				interval={interval}
				setInterval={setInterval}
				startDate={startDate}
				setStartDate={setStartDate}
				endDate={endDate}
				setEndDate={setEndDate}
				forecastEn={forecastEn}
				setForecastEn={setForecastEn}
				showForecastBtn={display === "charts"}
			/>

			{
				display === "charts" &&
					<>
						<Charts data={dataWithForecast} type={type} />
						{deviceObj && <Row>
							<Column>
								<div className={styles.weatherWidgetContainer}>
									<WeatherWidget
										lat={deviceObj.lat}
										lng={deviceObj.lng}
										location={device}
										type="forecast"
									/>
								</div>
							</Column>
						</Row>}
					</>
			}
			{
				display === "table" && <Tables data={data} type={type}/>
			}
		</div>
	);
}
